import axios from 'axios'

const API_BASE_URL = '/api/dashboard'

/**
 * Widget API Service
 * Handles all widget-related API calls to the Django backend
 */

const widgetApi = {
  /**
   * Get all widget categories
   */
  getCategories: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/widget-categories/`)
      return response.data
    } catch (error) {
      console.error('Error fetching widget categories:', error)
      throw error
    }
  },

  /**
   * Get a specific widget category with its widgets
   */
  getCategory: async (categoryId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/widget-categories/${categoryId}/`)
      return response.data
    } catch (error) {
      console.error('Error fetching category:', error)
      throw error
    }
  },

  /**
   * Get all widgets in a specific category
   */
  getCategoryWidgets: async (categoryId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/widget-categories/${categoryId}/widgets/`)
      return response.data
    } catch (error) {
      console.error('Error fetching category widgets:', error)
      throw error
    }
  },

  /**
   * Get all master widgets
   */
  getAllWidgets: async (filters = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/master-widgets/`, {
        params: filters
      })
      return response.data
    } catch (error) {
      console.error('Error fetching all widgets:', error)
      throw error
    }
  },

  /**
   * Get widgets grouped by category
   */
  getWidgetsByCategory: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/master-widgets/by_category/`)
      return response.data
    } catch (error) {
      console.error('Error fetching widgets by category:', error)
      throw error
    }
  },

  /**
   * Get featured widgets
   */
  getFeaturedWidgets: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/master-widgets/featured/`)
      return response.data
    } catch (error) {
      console.error('Error fetching featured widgets:', error)
      throw error
    }
  },

  /**
   * Get a specific widget by ID
   */
  getWidget: async (widgetId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/master-widgets/${widgetId}/`)
      return response.data
    } catch (error) {
      console.error('Error fetching widget:', error)
      throw error
    }
  },

  /**
   * Search widgets
   */
  searchWidgets: async (query) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/master-widgets/`, {
        params: {
          search: query
        }
      })
      return response.data
    } catch (error) {
      console.error('Error searching widgets:', error)
      throw error
    }
  },

  /**
   * Get widgets summary with statistics
   */
  getWidgetsSummary: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/widgets-summary/`)
      return response.data
    } catch (error) {
      console.error('Error fetching widgets summary:', error)
      throw error
    }
  },

  /**
   * Get user's widget presets
   */
  getMyPresets: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/widget-presets/my_presets/`)
      return response.data
    } catch (error) {
      console.error('Error fetching my presets:', error)
      throw error
    }
  },

  /**
   * Get public widget presets
   */
  getPublicPresets: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/widget-presets/public_presets/`)
      return response.data
    } catch (error) {
      console.error('Error fetching public presets:', error)
      throw error
    }
  },

  /**
   * Create a new widget preset
   */
  createPreset: async (presetData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/widget-presets/`,
        presetData
      )
      return response.data
    } catch (error) {
      console.error('Error creating preset:', error)
      throw error
    }
  },

  /**
   * Update a widget preset
   */
  updatePreset: async (presetId, presetData) => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/widget-presets/${presetId}/`,
        presetData
      )
      return response.data
    } catch (error) {
      console.error('Error updating preset:', error)
      throw error
    }
  },

  /**
   * Delete a widget preset
   */
  deletePreset: async (presetId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/widget-presets/${presetId}/`
      )
      return response.data
    } catch (error) {
      console.error('Error deleting preset:', error)
      throw error
    }
  }
}

export default widgetApi
